import React from "react";

import {
  ResponsiveSelect,
  SelectSheetOption,
} from "../../../../../components/MobileForm";
import { Pagination } from "../../../../../components/Pagination";
import { PAGE_SIZE_LABEL, PAGE_SIZE_OPTIONS } from "./constants";
import { PageSizeControl, Pager, PagerGrow } from "./styles";
import { ProgressPagerProps } from "./types";

const summaryOf = ({
  start,
  shownCount,
  matchCount,
  totalCount,
  isNarrowed,
}: ProgressPagerProps): string => {
  if (matchCount === 0) {
    return `No matches (${totalCount} total)`;
  }
  const range = `Showing ${start + 1}–${start + shownCount} of ${matchCount}`;
  return isNarrowed ? `${range} matching (${totalCount} total)` : range;
};

const ProgressPagerComponent: React.FC<ProgressPagerProps> = (props) => {
  const {
    page,
    pageCount,
    pageSize,
    isCompact,
    onPageChange,
    onPageSizeChange,
  } = props;
  const handlePageSizeChange = (option: SelectSheetOption) =>
    onPageSizeChange(Number(option.value));

  return (
    <Pager>
      <PagerGrow>
        <Pagination
          page={page}
          pageCount={pageCount}
          onPageChange={onPageChange}
          ariaLabel="Progress pages"
          summary={summaryOf(props)}
        />
      </PagerGrow>
      <PageSizeControl>
        <span aria-hidden={true}>{PAGE_SIZE_LABEL}</span>
        <ResponsiveSelect
          isCompact={isCompact}
          options={PAGE_SIZE_OPTIONS}
          value={String(pageSize)}
          onChange={handlePageSizeChange}
          sheetTitle={PAGE_SIZE_LABEL}
          testId="progress-page-size"
        />
      </PageSizeControl>
    </Pager>
  );
};

export const ProgressPager = React.memo(ProgressPagerComponent);
